import React, { useEffect, useState } from 'react'
import { CustomSpanComponent } from './Span-component/CustomSpanComponent'
import logger from '../../../../../utils/logger'


export const AccountKitShipping = ({ memberData }) => {

  logger.warn('AccountKitShipping memberData: ', memberData)

  const [data, setData] = useState(null)

  useEffect(() => {

    if (memberData) {
      setData(memberData)
    }

  }, [memberData])


  const kit = memberData?.kitDeliveries && memberData.kitDeliveries.length > 0 ? memberData.kitDeliveries[0] : null;
  const hasEnrollment = !!memberData?.yearOfEnrollment;


  

const renderContent = () => {
    //?  Si ya realizó la formación  yearOfEnrollment != null
    if (hasEnrollment) {
      return (
        <div className='user-dto '>
          <div className="retirement-tpa">
            <p className="p-store-title d-flex align-item-center">No Aplica</p>
          </div>
        </div>

      );
    }

    //?  Si no tiene kitDelivery (Formulario con guiones)
    if (!kit) {
      return (
         <>

        <CustomSpanComponent
        userData={'-'}
        label={'Dirección'}
      />

       <CustomSpanComponent
        userData={'-'}
        label={'Código Postal'}
      />

      <CustomSpanComponent
        userData={'-'}
        label={'Información adicional (Barrio, Piso, Dpto, etc)'}
      />


        <CustomSpanComponent
        userData={'-'}
        label={'Localidad'}
      />

        <CustomSpanComponent
        userData={'-'}
        label={'Provincia'}
      />

      </>
      );
    }

    //? Si es Pickup === true (Retiro presencial)
    if (kit.pickup) {
      return (
        <div className="retirement-tpa">
          <div className="iRetirement-container">
            <span className="material-symbols-outlined notranslate mI-subscription">store</span>
          </div>
          <div className="store-container">
            <p className="p-store-title">Retiro por Instituto Vianett® en Córdoba Capital</p>
            <hr />
            <p className="p-store">Cosquín 1222, X5000 Córdoba</p>
          </div>
        </div>
      );
    }

    //? Si Pickup === false (Envío a domicilio)
    return (
    
        <>

        <CustomSpanComponent
        userData={kit.address || '-'}
        label={'Dirección'}
      />

       <CustomSpanComponent
        userData={kit.zipCode || '-'}
        label={'Código Postal'}
      />
       
       <CustomSpanComponent
        userData={kit.addressAdditionalData || '-'}
        label={'Información adicional (Barrio, Piso, Dpto, etc)'}
      />

        <CustomSpanComponent
        userData={kit?.city || '-'}
        label={'Localidad'}
      />

        <CustomSpanComponent
        userData={kit?.province || '-'}
        label={'Provincia'}
      />

      </>
    );
  };



  return (
    <div className="mp-user-dto bg-mp-white">

      <h4 className="mp-header-nav-title">Envío de Kit</h4>


      {renderContent()}

  
    </div>
  )
}
